import { LogOut, ShieldCheck } from "lucide-react";

const SESSION_KEY = "dishly_admin_user";

export default function AccountTab({ onLogout }) {
  const me = JSON.parse(localStorage.getItem(SESSION_KEY) || "{}");
  return (
    <div className="space-y-5" data-testid="account-tab">
      <div className="rounded-2xl border border-black/5 bg-white p-6 text-center">
        <div className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-terracotta/10 text-terracotta">
          <ShieldCheck className="h-7 w-7" />
        </div>
        <p className="mt-3 font-display text-xl font-bold text-charcoal" data-testid="account-name">{me.name || "Admin"}</p>
        <p className="mt-0.5 text-sm text-charcoal/55" data-testid="account-email">{me.email}</p>
        <span className="mt-3 inline-block rounded-full bg-charcoal/5 px-3 py-1 text-xs font-bold uppercase tracking-wide text-charcoal/60">Admin</span>
      </div>
      <p className="rounded-2xl border border-black/5 bg-cream/60 p-4 text-center text-[13px] leading-relaxed text-charcoal/60">
        This is the same admin account as your Dishly app. Everything you do here happens in the live app instantly.
      </p>
      <button onClick={onLogout} data-testid="account-logout-btn"
        className="flex w-full items-center justify-center gap-2 rounded-2xl bg-charcoal py-3.5 text-sm font-bold text-cream transition-transform hover:scale-[1.01]">
        <LogOut className="h-4 w-4" /> Log out
      </button>
    </div>
  );
}
